import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Grid } from "@material-ui/core";
import { AREAS_USUARIOS, AUTORIZACIONES_BANDEJAS, AUTORIZACIONES_SOLICITUDES_ESTADOS, MENU_AUTORIZACIONES } from "../../utils/constants";
import { AutorizacionesBreadcrumb } from "./UI/AutorizacionesBreadcrumb";
import { AutorizacionesIngresoHome } from "./Ingreso/AutorizacionesIngresoHome";
import { GestionAuditoriaHome } from "./gestionAuditoria/GestionAuditoriaHome";
import { AdministrarSolicitudes } from "./administrarSolicitudes/AdministrarSolicitudes";
import { GestionPresupuestosHome } from "./gestionPresupuestos/GestionPresupuestosHome";
import { cleanPresupuestosTomados, cleanSolicitudesTomadas, getPresupuestosTomadosPorUsuario, getSolicitudesTomadasPorUsuario, setEstadoSolicitudes } from "../../actions/autorizaciones/Autorizaciones";
import { AdministrarPresupuestos } from "./administrarPresupuestos/AdministrarPresupuestos";
import { AUTORIZACIONES_MENU_PERMISOS, AUTORIZACIONES_PERMISOS } from "../../utils/permisos";
import { validarSoloUnPermiso } from "../../helpers/permisos";
import { SeguimientoSolicitudesHome } from "./buscador/SeguimientoSolicitudesHome";

const style = {
  root: {
    flexGrow: 1,
  },
};

export const AutorizacionesHome = (props) => {

  const dispatch = useDispatch();
  const { permisos: permisosUser, areas, bandejasAutorizacion = [] } = useSelector((state) => state.auth);
  const { solicitudesTomadasUsuario, presupuestosTomadosUsuario } = useSelector((state) => state.autorizaciones);

  const [activeBreadcrumb, setActiveBreadcrumb] = useState();
  const [permisoIngresoInterDom, setPermisoIngresoInterDom] = useState(false);
  const [permisoIngresoOxigeno, setPermisoIngresoOxigeno] = useState(false);

  const resetRouteStateAndSetActiveBreacDrumb = (item) => {
    props.location.state = { from: props.location.pathname };
    setActiveBreadcrumb(item)
  }
  
  const esSoloAfiliaciones = bandejasAutorizacion.length === 1
  && bandejasAutorizacion.filter(s => s.idBandeja === AUTORIZACIONES_BANDEJAS.AFILIACIONES).length === 1;

  useEffect(() => {
    if (props.location.state?.from !== "/autorizaciones/gestion") {
      dispatch(cleanSolicitudesTomadas());
      dispatch(cleanPresupuestosTomados());
      if (areas.filter((area) => area.idArea === AREAS_USUARIOS.AUTORIZACIONES_NACIONAL 
      || area.idArea === AREAS_USUARIOS.AUTORIZACIONES_SECCIONAL)?.length > 0) {
        dispatch(getSolicitudesTomadasPorUsuario());
        dispatch(getPresupuestosTomadosPorUsuario());
      }
      if (props.location.state?.fromHomeScreen) {
        if (props.location.state?.idBandejaAutorizacion === AUTORIZACIONES_BANDEJAS.AUDITORIA_TERRENO) {
          dispatch(setEstadoSolicitudes(AUTORIZACIONES_SOLICITUDES_ESTADOS.AUDITORIA_TERRENO.toString()));
        } else if (props.location.state?.idBandejaAutorizacion === AUTORIZACIONES_BANDEJAS.INTERNACION_PAIS) {
          dispatch(setEstadoSolicitudes(AUTORIZACIONES_SOLICITUDES_ESTADOS.INTERNACION_PAIS.toString()));
        } else if (props.location.state?.idBandejaAutorizacion === AUTORIZACIONES_BANDEJAS.INTERNACION_DOMICILIARIA) {
          dispatch(setEstadoSolicitudes(AUTORIZACIONES_SOLICITUDES_ESTADOS.INTERNACION_DOMICILIARIA.toString()));
        }
      }

      if (props.location.state?.sendGestion)
        setActiveBreadcrumb(MENU_AUTORIZACIONES.GESTION_AUDITORIA);

    } else {
      setActiveBreadcrumb(MENU_AUTORIZACIONES.INGRESO_AUTORIZACION);
    }

    if (props.location.state?.activeBreadcrumb) {
      setActiveBreadcrumb(props.location.state.activeBreadcrumb);
    }

  }, [props.location.state?.from, props.location.state?.fromHomeScreen, dispatch]);

  useEffect(() => {
    setPermisoIngresoInterDom(validarSoloUnPermiso(permisosUser,
      AUTORIZACIONES_PERMISOS.INGRESO_INTERNACION_DOMICILIARIA
    ));
    setPermisoIngresoOxigeno(validarSoloUnPermiso(permisosUser,
      AUTORIZACIONES_PERMISOS.INGRESO_OXIGENO
    ));
  }, [permisosUser]);

  // console.log(props.location.state)
  return (
    <div className={style.root}>
      <Grid
        container
        spacing={1}
        direction="row"
        justify="center"
        alignItems="center"
      >
        <Grid item xs={12} styles={{ padding: 5 }}>
          <AutorizacionesBreadcrumb
            setActiveBreadcrumb={resetRouteStateAndSetActiveBreacDrumb}
            permisoIngresoInterDom={permisoIngresoInterDom}
            validarSoloUnPermiso={validarSoloUnPermiso}
            activeBreadcrumb={activeBreadcrumb}
            permisosUser={permisosUser}
            areasUser={areas}
            esSoloAfiliaciones={esSoloAfiliaciones}
          />
        </Grid>
        {!activeBreadcrumb && solicitudesTomadasUsuario.length > 0 &&
          <AdministrarSolicitudes
            type={'currentUser'}
          />
        }
        {!activeBreadcrumb && presupuestosTomadosUsuario.length > 0 &&
          <AdministrarPresupuestos
            type={'currentUser'}
          />
        }
        {activeBreadcrumb === MENU_AUTORIZACIONES.INGRESO_AUTORIZACION && (
          <AutorizacionesIngresoHome
            permisoIngresoInterDom={permisoIngresoInterDom}
            fromGestion={
              props.location.state?.from === "/autorizaciones/gestion"
                ? true
                : false
            }
          />
        )}
        {activeBreadcrumb === MENU_AUTORIZACIONES.GESTION_AUDITORIA && (
          <GestionAuditoriaHome
            permisoIngresoInterDom={permisoIngresoInterDom}
            permisoIngresoAutorizaciones={validarSoloUnPermiso(permisosUser,
              AUTORIZACIONES_MENU_PERMISOS.INGRESO_AUTORIZACION
            )}
            permisoIngresoOxigeno={permisoIngresoOxigeno}
            {...props}
          />
        )}
        {activeBreadcrumb === MENU_AUTORIZACIONES.GESTION_PRESUPUESTOS && (
          <GestionPresupuestosHome {...props} fromCompras={false} />
        )}
        {activeBreadcrumb === MENU_AUTORIZACIONES.BUSCADOR && (
          <SeguimientoSolicitudesHome {...props} />
        )}
      </Grid>
    </div>
  );
};
